import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Layout } from 'blaze-validator';

import api from '../../services/ApiService';
import Form from '../form/Form';
import LoadingPage from '../LoadingPage';

class ModalPartCalculation extends Component {
  constructor(props) {
    super(props);

    // Form Config
    this.layout = [
      {
        type: 'string',
        name: 'partNumber',
        data: props.lookupKey,
        hidden: true,
      },
      {
        col: 6,
        type: 'string',
        name: 'activityPeriod',
        label: 'Activity Period in Weeks',
        noEmptyOption: true,
        options: ['2', '4', '6', '8', 'ALL'],
        data: '2',
      },
      {
        col: 6,
        name: 'useStockOrderWeights',
        label: 'Use Stock Order Weights',
        noEmptyOption: true,
        options: [
          { label: 'Yes', value: 'Y' },
          { label: 'No', value: 'N' },
        ],
        data: 'No',
      },
      {
        col: 6,
        name: 'longTermWeight',
        label: 'Long Term Weight',
        data: '',
      },
      {
        col: 6,
        name: 'shortTermWeight',
        label: 'Short Term Weight',
        data: '',
      },
      {
        col: 6,
        name: 'safetyStockLevel',
        label: 'Safety Stock Level in Days',
        data: '',
      },
      {
        col: 6,
        name: 'stockLevel',
        label: 'Stocking Level in Days',
        data: '',
      },
      {
        col: 6,
        name: 'reOrderLevel',
        label: 'Reorder Level in Days',
        data: '',
      },
      {
        col: 6,
        name: 'longTermSales',
        label: 'Long Term Sales',
        data: '',
      },
    ];

    this.state = {
      results: '',
    };

    this.title = 'Part Order Calculation';

    this.submit = this.submit.bind(this);
    this.submitCallback = this.submitCallback.bind(this);
    this.reset = this.reset.bind(this);

    // DBPPRD ||A:107296X*|2290|
    this.state = {
      isReady: false,
      layout: [],
    };
  }

  componentDidMount() {
    this.reset();
  }

  getSettings() {
    const { lookupKey } = this.props;
    api.get(`/part/${encodeURIComponent(lookupKey)}/calculation/settings`).then(response => {
      const { data } = response;
      const layout = new Layout(this.layout);
      const { defaultStockingLevel, safetyStock, ...rest } = data;
      layout.populateLayout({ stockLevel: defaultStockingLevel, safetyStockLevel: safetyStock, ...rest });
      this.setState({
        isReady: true,
        layout: layout.getLayout(),
      });
    });
  }

  submit(payload) {
    const part = payload[0].data;

    const params = {};
    payload.forEach(param => {
      params[param.name] = param.data;
    });

    return api.get(`part/${encodeURIComponent(part)}/calculation`, { params });
  }

  reset() {
    this.props.setTitle(this.title);
    this.setState({ results: '' }, this.getSettings);
  }

  submitCallback(response) {
    this.props.setTitle(
      <div className="modal-icon-title">
        <div className="icon-wrapper">
          <i className="zmdi zmdi-arrow-left" onClick={this.reset} />
        </div>
        <div className="title-wrapper">Part Order Calculation</div>
      </div>
    );
    this.setState({ results: response.data.data });
  }

  render() {
    if (!this.state.isReady) {
      return <LoadingPage />;
    }

    const entryClass = classNames({
      'entry-form': true,
      hidden: this.state.results,
      animated: true,
      fadeIn: !this.state.results,
    });

    const resultClass = classNames({
      'result-panel': true,
      hidden: !this.state.results,
      animatedFast: true,
      slideInRight: this.state.results,
    });

    return (
      <div>
        <div className={entryClass}>
          <Form
            layout={this.state.layout}
            submit={this.submit}
            submitCallback={this.submitCallback}
            onCancel={this.props.close}
            feedback="none"
            action="process"
            submitAll
          />
        </div>
        <div className={resultClass}>
          <pre>{this.state.results}</pre>
        </div>
      </div>
    );
  }
}

ModalPartCalculation.defaultProps = {
  lookupKey: null,
};

ModalPartCalculation.propTypes = {
  lookupKey: PropTypes.string,
  setTitle: PropTypes.func,
  close: PropTypes.func,
};

export default ModalPartCalculation;
